<svg [attr.viewBox]="'0 0 ' + width + ' ' + height" [attr.preserveAspectRatio]="aspectRatio">
  <path [attr.stroke-width]="strokeWidth" fill="none"></path>
  <circle
    *ngFor="let dot of dotPositions"
    class="dot"
    [attr.cx]="dot.cx"
    [attr.cy]="dot.cy"
    r="3.5"
  ></circle>
  <ng-container *ngFor="let label of labelPositions">
    <text
      *ngIf="label.show"
      [attr.x]="label.x"
      [attr.y]="label.y"
      class="label"
      text-anchor="middle"
    >
      {{ label.text }}
    </text>
  </ng-container>
</svg>
